// Use the layout viewport, not the keyboard/pinch-zoom viewport, for layout decisions.
export const MOBILE_QUERY = '(max-width: 768px), (max-width: 960px) and (max-height: 540px) and (orientation: landscape) and (pointer: coarse)'

export function isMobileViewport() {
  return window.matchMedia(MOBILE_QUERY).matches
}

export function watchMobileViewport(callback) {
  const query = window.matchMedia(MOBILE_QUERY)
  const listener = () => callback(query.matches)
  if (query.addEventListener) query.addEventListener('change', listener)
  else query.addListener(listener)
  return () => {
    if (query.removeEventListener) query.removeEventListener('change', listener)
    else query.removeListener(listener)
  }
}

export default {
  data() { return { jlIsMobile: isMobileViewport() } },
  mounted() {
    this._jlStopViewport = watchMobileViewport(value => { this.jlIsMobile = value })
  },
  beforeDestroy() {
    if (this._jlStopViewport) this._jlStopViewport()
  }
}



// WEBPACK FOOTER //
// ./src/utils/mobileViewport.js